const microService = {
  AUTH: "/auth/rest/v1/oauth/"
};

export const endpoints = {
  LOGIN: `auth/rest/v1/oauth/clients/`,
  PROFILE: ``,
  LOGOUT: ``,
  // NEAP
  EMPLOYEE_VERIFY: `${microService.AUTH}clients/${process.env.REACT_APP_CLIENT_ID}/employee/verify`,
  VERIFY_OTP: `${microService.AUTH}authorize/token`,
  RESEND_OTP: `${microService.AUTH}clients/${process.env.REACT_APP_CLIENT_ID}/otp/resend`,
  LOGOUT_EMPLOYEE: `${microService.AUTH}clients/${process.env.REACT_APP_CLIENT_ID}/logout`,
  EMPLOYEE_DETAILS: `${microService.AUTH}clients/${process.env.REACT_APP_CLIENT_ID}/employee`,
  REGISTER_EMPLOYEE: `/neap-tests/v1/employee/register`
};

export const loginTypes = {
  LOGIN_REQUEST: "student/login/LOGIN_REQUEST",
  LOGIN_SUCCESS: "student/login/LOGIN_SUCCESS",
  LOGIN_ERROR: "student/login/LOGIN_ERROR",
  RESET_ERROR: "student/login/RESET_ERROR",

  LOGOUT_REQUEST: "student/login/LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "student/login/LOGOUT_SUCCESS",
  LOGOUT_ERROR: "student/login/LOGOUT_ERROR",

  PROFILE_REQUEST: "student/login/PROFILE_REQUEST",
  PROFILE_SUCCESS: "student/login/PROFILE_SUCCESS",
  PROFILE_ERROR: "student/login/PROFILE_ERROR",

  // NEAP
  EMPLOYEE_VERIFY_REQUEST: "student/login/EMPLOYEE_VERIFY_REQUEST",
  EMPLOYEE_VERIFY_SUCCESS: "student/login/EMPLOYEE_VERIFY_SUCCESS",
  EMPLOYEE_VERIFY_ERROR: "student/login/EMPLOYEE_VERIFY_ERROR",
  EMPLOYEE_ERROR_RESET: "student/login/EMPLOYEE_ERROR_RESET",

  OTP_VERIFY_REQUEST: "student/login/OTP_VERIFY_REQUEST",
  OTP_VERIFY_SUCCESS: "student/login/OTP_VERIFY_SUCCESS",
  OTP_VERIFY_ERROR: "student/login/OTP_VERIFY_ERROR",
  OTP_VERIFY_RESET: "student/login/OTP_VERIFY_RESET",

  RESEND_OTP_REQUEST: "student/login/RESEND_OTP_REQUEST",
  RESEND_OTP_SUCCESS: "student/login/RESEND_OTP_SUCCESS",
  RESEND_OTP_ERROR: "student/login/RESEND_OTP_ERROR",

  REFRESH_TOKEN_REQUEST: "student/login/REFRESH_TOKEN_REQUEST",
  REFRESH_TOKEN_SUCCESS: "student/login/REFRESH_TOKEN_SUCCESS",
  REFRESH_TOKEN_ERROR: "student/login/REFRESH_TOKEN_ERROR",

  LOGOUT_EMPLOYEE_REQUEST: "student/login/LOGOUT_EMPLOYEE_REQUEST",
  LOGOUT_EMPLOYEE_SUCCESS: "student/login/LOGOUT_EMPLOYEE_SUCCESS",
  LOGOUT_EMPLOYEE_ERROR: "student/login/LOGOUT_EMPLOYEE_ERROR",

  GET_EMPLOYEE_DETAILS_REQUEST: "employee/login/GET_EMPLOYEE_DETAILS_REQUEST",
  GET_EMPLOYEE_DETAILS_SUCCESS: "employee/login/GET_EMPLOYEE_DETAILS_SUCCESS",
  GET_EMPLOYEE_DETAILS_ERROR: "employee/login/GET_EMPLOYEE_DETAILS_ERROR",
  REGISTER_EMPLOYEE_REQUEST: "student/login/REGISTER_EMPLOYEE_REQUEST",

  REDIRECTING_TYPE: "employee/login/REDIRECTING_TYPE"
};
